// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"paginationContainer--d72Xt","top":"top--nCh2l"};